import { string, object, array } from 'yup';

export const validationSchema = array().of(
  object().shape({
    content: string().required('Note content is required'),
    category: string().required('Note category is required'),
  }),
);
